import { Sensors, SensorsOffRounded } from '@mui/icons-material';
import { blue, grey } from '@mui/material/colors';
import { ReactComponent as BadIcon } from '../assets/images/icons/bad-icon.svg';
import { ReactComponent as ModerateIcon } from '../assets/images/icons/bell-icon.svg';
import { ReactComponent as VIcon } from '../assets/images/icons/v-circle-icon.svg';
// import { ReactComponent as BellIcon } from '../assets/images/icons/bell-icon.svg';

// Note: the numeric values should match with the solin_status value in the InfluxDB.
export const Status = {
  Bad: 3,
  Medium: 2,
  Good: 1,
  Disconnected: 4,
  Default: 5,
};

export const StatusColor = {
  // [Status.Bad]: [pink[300], red[600]],
  [Status.Bad]: ['#BE1E2D', '#BE1E2D'],
  // [Status.Medium]: [yellow[500], amber[800]],
  [Status.Medium]: ['#FCB400', '#FCB400'],
  // [Status.Good]: [lightGreen[300], teal[500]],
  [Status.Good]: ['#00A551', '#00A551'],
  [Status.Disconnected]: [grey[400], grey[600]],
  [Status.Default]: [blue[400], blue[600]],
};

export const StatusIcon = {
  // [Status.Bad]: <PriorityHighIcon />,
  [Status.Bad]: <BadIcon />,
  // [Status.Medium]: <NotificationsNoneIcon />,
  [Status.Medium]: <ModerateIcon />,
  // [Status.Good]: <CheckRounded />,
  [Status.Good]: <VIcon />,
  [Status.Disconnected]: <SensorsOffRounded />,
  [Status.Default]: <Sensors />,
};
